/**
 * Helpers for sessionStorage.
 */

function reportSessionStorageError(error: unknown): void {
  if (window.__UNIT_TESTING === true) {
    return
  }
  window.Sentry?.captureException(error)
}

export function getSessionItem<T>(key: string): T | null {
  try {
    const raw = sessionStorage.getItem(key)
    if (!raw) {
      return null
    }
    return JSON.parse(raw) as T
  } catch (error) {
    reportSessionStorageError(error)
    return null
  }
}

export function setSessionItem<T>(key: string, value: T): void {
  try {
    sessionStorage.setItem(key, JSON.stringify(value))
  } catch (error) {
    reportSessionStorageError(error)
  }
}

export function removeSessionItem(key: string): void {
  try {
    sessionStorage.removeItem(key)
  } catch (error) {
    reportSessionStorageError(error)
  }
}
